import { defineComponent as _defineComponent } from 'vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OzTextLink',
  props: {
    darkMode: { type: [String, Boolean], default: 'auto' },
    href: null,
    text: null
  },
  setup(__props: any) {



return { __sfc: true,OzBaseButton }
}

})